export var defaultProps = {
  direction: "row",
  wrap: "nowrap",
  display: "flex"
};